import * as React from "react";
import {FormattedMessage} from "react-intl";

const URL_REGEX: RegExp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i);

export default (value: any) => {

    if(typeof value !== "string" || value === '') {
        return undefined;
    }

    if(!URL_REGEX.test(value)) {
        return <FormattedMessage id="form.validations.email.invalid" />;
    }

    return undefined;
};